__turbopack_context__.v({
  "banner-tile": "movie-showtimes-scroller-module-scss-module__PIIImW__banner-tile",
});
